import request from '@/utils/request'

export function getInfo() {
  return request({
    url: 'sqjspx2026/check_login',
    method: 'get'
  })
}

export function fetchCategory() {
  return request({
    url: 'sqjspx2026/category',
    method: 'get'
  })
}

export function fetchList(query) {
  return request({
    url: 'sqjspx2026/list',
    method: 'get',
    params: query
  })
}

export function fetchDetail(sn) {
  return request({
    url: 'sqjspx2026/detail',
    method: 'get',
    params: {
      sn: sn
    }
  })
}

export function videoAuth(param) {
  return request({
    url: 'sqjspx2026/make_token',
    method: 'get',
    params: param
  })
}
